/** Actual ID lookups from database */
export enum PortfolioAnalysisCategoryEnum {
  analysisOfCurrentHoldings = 7,
  analysisAndProposal = 8,
  fullFinancialPlan = 9,
}